import { Auth0Provider } from "@auth0/auth0-react";
import type React from "react";
import { useState } from "react";

import { AUTH0_CLIENT_ID, AUTH0_DOMAIN, PUBLIC_PATHS } from "~app/constants";
import { AuthChecking } from "./components/AuthChecking";

type Props = {
  children?: React.ReactNode;
};

export const AuthProvider: React.FC<Props> = ({ children }: Props) => {
  const [appState, setAppState] = useState(null);
  const onRedirectCallback = (appState: any) => {
    setAppState(appState);
    window.location.href = appState?.returnTo || window.location.origin;
  };

  const isPublicPage = PUBLIC_PATHS.includes(window.location.pathname);

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {isPublicPage ? children : <AuthChecking appState={appState}>{children}</AuthChecking>}
    </Auth0Provider>
  );
};
